import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "../Works/works.scss";
import Button from "react-bootstrap/Button";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [header, setHeader] = useState("");
  const [activeProject, setActiveProject] = useState("laravel");

  const fetchProjects = async (project_title) => {
    try {
      const response = await fetch(`/${project_title}.json`); // Assuming `html.json` is in the public folder
      const data = await response.json();
      setHeader(data.project_header); // Set the header
      setProjects(data.data); // Set the project data
      setActiveProject(project_title); // Set the active project
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects("laravel"); // Fetch default projects on initial render
  }, []);
  return (
    <>
      <section id="works" className="work py-5">
        <Container className="py-md-5">
          <div className="text-center mb-4">
            <h5 className="title-small text-uppercase">Portfolio</h5>
            <h3 className="fs-1 fw-bold">Some of my most recent projects</h3>
          </div>
          <Row className="py-5">
            <div className="d-flex flex-wrap gap-2 mb-5 justify-content-start">
              <Button
                onClick={() => fetchProjects("laravel")}
                className={`project-btn ${activeProject === "laravel" ? "active-btn" : ""}`}
              >
                LARAVEL - Projects
              </Button>
              <Button
                onClick={() => fetchProjects("mern_p")}
                className={`project-btn ${activeProject === "mern_p" ? "active-btn" : ""}`}
              >
                MERN - Projects
              </Button>
            </div>

            <h2>{header ? header : ""}</h2>
            <br />
            <br />
            <br />
            {/* API call start */}
            {projects.map((project, index) => (
              <Col className="mb-4" xs={12} md={6} lg={4} key={project.id}>
                <Card style={{ height: "auto" }}>
                  <Card.Img variant="top" src={project.image} />

                  <Card.Body>
                    <Card.Title className="fs-4">{project.title}</Card.Title>

                    <Card.Text>
                      <ul>
                        {project.features.map((feature, i) => (
                          <li key={i}>{feature}</li>
                        ))}
                      </ul>
                      <span className="fw-bold">Used:</span>{" "}
                      {project.technology.join(", ")}
                    </Card.Text>

                    <div className="d-flex justify-content-between flex-wrap gap-2">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="card__btn"
                        href={project.client_code}
                      >
                        Client Code
                      </a>

                      {project.server_code && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="card__btn"
                          href={project.server_code}
                        >
                          Server Code
                        </a>
                      )}
                    </div>

                    <div className="d-flex justify-content-between mt-3 flex-wrap gap-2">
                      {project.details && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="card__btn"
                          href={project.details}
                        >
                          Details
                        </a>
                      )}

                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="card__btn"
                        href={project.live}
                      >
                        Live Site
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Projects;
